import { updatePaidAmount, updateTransactionType, updateTipAmount, showConfirmCta, updatePaymentType, resetReference, handleSaveSaleData, updatePaymentFlow, updateInfoModal, updateSaleStatus, updateToastInfo, hideFullPayment, updatePaymentToServer, updatePaymentModal, updateSelectedPayment, setRistaCardList } from "redux-store/slices/CheckoutSlice";
import { updateLocalPaymentInfo, updateStrip } from "redux-store/slices/LocalPaymentInfo";
import { selectedLoyaltyDetails } from "redux-store/slices/Loyalty";
import { getErrorMessage } from "utils/pos_errors";
import store from "../redux-store/index";
import { handleWarningModal, roundOffTwoDecimal } from "./commonHelpers";
import { calculateAndSaveSaleData, calculateSale, getClonedSaleDataFromReducer, hasItemLeveErrors, roundOffBillAmount } from "./saleHelpers";
import { orderLevelError } from "redux-store/slices/GlobalSlice";
import { saveSaleData } from "redux-store/slices/SaleSlice";
import { COUPON, ERROR, EXTERNAL, FAILED, REFERENCE_ERROR, REQUESTED, SALE_RETURN_TYPE } from "utils/constants";
import { FULL_PAYMENT_KEY, PARTIAL_PAYMENT_KEY, SELECTED_PAYMENT_STORE_SELECTED_PAYMENT, SPLIT_PAYMENT_KEY } from "utils/checkoutConstants";
import { closeSaleFn, saleCheckoutSave } from "facade/ServiceFacade";
import { DISABLED_PAYMENTS, DISCOUNT_MODES, INSUFFICIENT_STOCK } from "data/constants";
import { paymentHelpers } from "@dotpe/rista-pos-common";
import { isEmpty } from "lodash";
import { arrayToMap } from "./catalogueHelpers";
import { ispaymentInProcess, setSalePaymentDetails } from "@rista/core/redux-store/slices/CustomerDisplay";
import { resetNcApproval } from "redux-store/slices/NcApprovalSlice";
var ObjectID = require("bson-objectid");
// export interface PaymentInfo {
//   balanceAmount: number,
//   tip: number,
//   paymentInfo: any
// }

export interface PaymentLegIF {
  mode: any,
  selectedLeg: any,
  source: any
}

export interface UpdatePaymentLegAmountIF {
  paidAmount: any,
  tip: number,
  revenue: number
}


const getUpdatedPaymentAmount: any = (isCash: boolean, selectedLeg: any, balanceAmount: number) => {
  if (isEmpty(selectedLeg)) {
    return balanceAmount;
  } else {
    const previousAmount = selectedLeg?.originalAmount || selectedLeg.amount;
    if (isCash || previousAmount <= balanceAmount) {
      return previousAmount;
    } else {
      return balanceAmount;
    }
  }
}

export const getPaymentLeg: any = (selectedPayment: any) => {
  let isSplitPayment = store.getState().checkoutModalStore.isSplitPayment, saleDataStore = store.getState().saleDataStore, salePaymentInfo = saleDataStore?.saleData?.paymentInfo || {}, payments = [], paymentInfo = store.getState().localPaymentInfoStore.paymentInfo;
  if (salePaymentInfo?.payments?.length) {
    payments = salePaymentInfo.payments;
  }
  if (isSplitPayment) {
    payments = [...payments, paymentLegStruct({ selectedPayment, paymentLeg: paymentInfo.payments, source: paymentInfo })]
  }
  else {
    payments = [...payments, paymentLegStruct({ mode: selectedPayment, source: paymentInfo })]
  }
  return payments;
}

export const paymentLegStruct: any = ({ mode, selectedLeg = {}, source }: PaymentLegIF) => {
  let balanceAmount: number,
    saleDataStore = store.getState().saleDataStore,
    modeData = newMapData(mode),
    saleRecord = saleDataStore?.saleData || {},
    transactionType = saleRecord?.transactionType || '',
    newPayment = new Map(),
    paymentInfo = newMapData(source);
  balanceAmount = paymentInfo.get('balanceAmount') as number;

  if (Object.keys(selectedLeg)?.length) {
    newPayment = newMapData(selectedLeg);
    if (!newPayment.get('paymentId')) {
      newPayment.set('paymentId', ObjectID().toHexString());
    }
  }
  else {
    if ((transactionType.toLowerCase() !== SALE_RETURN_TYPE) && modeData.get('mode') !== 'Prepaid' && modeData.get('mode')
      !== 'Loyalty') {
      balanceAmount = balanceAmount > 0 ? balanceAmount : 0;
    } else {
      balanceAmount = transactionType.toLowerCase() !== SALE_RETURN_TYPE ? Math.abs(balanceAmount) : balanceAmount;
    }
    if (!newPayment.get('paymentId')) {
      newPayment.set('paymentId', ObjectID().toHexString());
    }
  }
  newPayment.set('type', modeData.get('type'));
  newPayment.set('mode', modeData.get('mode'));
  newPayment.set('isCash', modeData.get('isCash'));
  const udpatedAmount = getUpdatedPaymentAmount(modeData.get('isCash'), selectedLeg, balanceAmount);
  newPayment.set('amount', udpatedAmount);
  
  if (modeData.get('referenceMandatory')) {
    newPayment.set('referenceMandatory', modeData.get('referenceMandatory'));
  }
  else {
    newPayment.delete('referenceMandatory');
  }
  if (modeData.get('reference')) {
    newPayment.set('reference', modeData.get('reference'))
  }
  else {
    newPayment.delete('reference');
  }
  if (modeData.get('meta')) {
    let meta = modeData.get('meta') as any;
    newPayment.set('pid', meta.pid);
    newPayment.set('img', meta.img);
  }
  else {
    newPayment.delete('pid');
    newPayment.delete('img');
  }
  let obj: any = {};
  newPayment.forEach((value: any, key: any) => {
    obj[key] = value;
  })
  return obj;
}

export const addCashAmounts: any = (balanceAmount: number, saleRecord: any) => {
  let addedAmount = 0, payments = [];
  if (balanceAmount) {
    if (saleRecord.transactionType !== 'Return') {
      payments.push({ amount: Math.ceil(balanceAmount) });
      getDefinedPaymentAmounts().forEach((item: any) => {
        addedAmount = balanceAmount - (balanceAmount % item) + item;
        payments.push({ amount: addedAmount });
      });
    }
  }
  store.dispatch(updateStrip({ showStrip: true, paymentsStrip: payments }))
}

export const showRefrenceStrip: any = () => {
  store.dispatch(updateStrip({ showStrip: true, showReference: true }))
}

export const newMapData: any = (mapData: any = {}) => {
  let mapDataList = new Map();
  if (Object.keys(mapData)?.length) {
    Object.keys(mapData).map((listItem) => {
      mapDataList.set(listItem, mapData[listItem])
    })
  }
  return mapDataList;
}

export const getDefinedPaymentAmounts: any = () => {
  let definedPaymentAmount = new Map();
  definedPaymentAmount.set(10, 10);
  definedPaymentAmount.set(100, 100);
  definedPaymentAmount.set(200, 200);
  definedPaymentAmount.set(500, 500);
  definedPaymentAmount.set(2000, 2000);
  return definedPaymentAmount;
}

export const resetCheckoutData: any = () => {
  store.dispatch(ispaymentInProcess(false));
  store.dispatch(updatePaidAmount("00.00"));
  store.dispatch(updateTipAmount(false));
  store.dispatch(updateStrip({}));
  store.dispatch(updateTransactionType(FULL_PAYMENT_KEY));
  store.dispatch(showConfirmCta(false));
  // store.dispatch(selectedLoyaltyDetails({}))
  store.dispatch(updatePaymentType(false));
  store.dispatch(hideFullPayment(false));
  store.dispatch(updatePaymentFlow(''));
  store.dispatch(updatePaymentModal(false));
  store.dispatch(updateSelectedPayment(false));
  store.dispatch(setRistaCardList([]));
  store.dispatch(setSalePaymentDetails(null));
  store.dispatch(resetNcApproval());
}

export const resetDataSwitchPayment: any = () => {
  store.dispatch(updateTipAmount(false));
  store.dispatch(updateStrip({}));
  store.dispatch(showConfirmCta(false));
  store.dispatch(updatePaymentType(false));
  store.dispatch(updatePaymentFlow(''));
  store.dispatch(updateSaleStatus({}));
}

export const handleCheckoutPaymentInfo: any = () => {
  let paymentInfo = structuredClone(store.getState().localPaymentInfoStore.paymentInfo),
    checkoutModalStore = store.getState().checkoutModalStore,
    saleData = store.getState().saleDataStore.saleData,
    selectedPayment: any = SELECTED_PAYMENT_STORE_SELECTED_PAYMENT,
    paidAmount = getPaymentAmount(paymentInfo?.payments);
  if ((selectedPayment?.isCash) && (paidAmount > saleData.billRoundedAmount + getTipAmount())) {
    paymentInfo.payments.push(updatePaymentLegAmount({ revenue: saleData.billRoundedAmount, tip: getTipAmount(), paidAmount: paidAmount }))
  }
  return paymentInfo;
}

export const updatePaymentLegAmount: any = (data: any) => {
  let amount: any = 0, { revenue, tip, paidAmount } = data;
  amount = revenue + tip - paidAmount;
  amount = (Math.round(amount * 100) / 100).toFixed(2);
  return {
    mode: 'Cash',
    amount: parseFloat(amount)
  }
}

export const handleNonChargableTransaction: any = () => {
  let saleDataObj = getClonedSaleDataFromReducer();
  saleDataObj = calculateSale(saleDataObj);
  saleDataObj.transactionType = "NC";
  saleDataObj = calculateSale(saleDataObj);
  saleDataObj.statusInfo = store.getState().checkoutModalStore.saleStatus;
  return saleDataObj;
}

export const prepareLocalPaymentInfo: any = (context: any, updateContext: any) => {
  let { payments } = context;
  const saleData = getClonedSaleDataFromReducer();
  let paymentInfo: any = {}, isSplitType = false, isExternalPaymentPresent = false;
  paymentInfo = { ...saleData.paymentInfo };
  payments = new Map();
  if (paymentInfo?.payments?.length) {
    paymentInfo.payments.map((paymentList: any) => {
      if (paymentList.type !== 'Coupon') {
        isSplitType = true;
      }
      if (paymentList.type === EXTERNAL && paymentList?.paymentStatus) isExternalPaymentPresent = true;
      if (!paymentList.paymentId) {
        payments.set(paymentList.reference, paymentList);
      }
      else {
        payments.set(paymentList.paymentId, paymentList);
      }
    })
  }
  updateContext({ selectedPayment: {}, payments });
  if (isSplitType) {
    store.dispatch(updateTransactionType(SPLIT_PAYMENT_KEY));
    if (isExternalPaymentPresent) store.dispatch(hideFullPayment(true));
  }

  store.dispatch(updateLocalPaymentInfo(paymentInfo));
}


export const preparePaymentInfo = (context: any, updateContext: any) => {
  let { selectedPayment, payments } = context;
  const saleData = getClonedSaleDataFromReducer();
  let paymentInfo: any = {}, isSplitType = false;
  paymentInfo = { ...saleData.paymentInfo };
  payments = new Map();
  if (paymentInfo?.payments?.length) {
    paymentInfo.payments.map((paymentList: any) => {
      if (!paymentList.paymentId) {
        payments.set(paymentList.type, paymentList);
      }
      else {
        payments.set(paymentList.paymentId, paymentList);
      }
    })
  }

  store.dispatch(updateLocalPaymentInfo(paymentInfo));
  return payments;
}

export const getPaymentInfo: any = (enteredAmount: any) => {
  const localPaymentInfo = store.getState().localPaymentInfoStore.paymentInfo,
    selectedPayment: any = SELECTED_PAYMENT_STORE_SELECTED_PAYMENT,
    saleData = store.getState().saleDataStore.saleData,
    checkoutModalStore = store.getState().checkoutModalStore;

  enteredAmount = parseFloat(enteredAmount);
  let paymentInfo: any = {}, paymentLeg = {}, balanceAmount: any = 0, paidAmount = enteredAmount;
  balanceAmount = parseFloat(roundOffTwoDecimal(localPaymentInfo.balanceAmount - enteredAmount));
  if (checkoutModalStore.transactionType !== 'partialPayment') {
    if (!selectedPayment?.isCash ) {
      if (enteredAmount > localPaymentInfo.balanceAmount + getTipAmount()) {
        return { paymentInfo, error: "Payment cannot be more than balance amount for non cash transactions." }
      }
      if (enteredAmount < localPaymentInfo.balanceAmount + getTipAmount() && !checkoutModalStore.isSplitPayment) {
        return { paymentInfo, error: "Payment cannot be less than balance amount for non cash transactions." }
      }
    }
    if (selectedPayment?.isCash) {
      if (enteredAmount < localPaymentInfo.balanceAmount + getTipAmount() && !checkoutModalStore.isSplitPayment) {
        return { paymentInfo, error: "Payment cannot be less than balance amount." }
      }
    }
  }
  paymentInfo = {
    balanceAmount: parseFloat(enteredAmount),
    tip: localPaymentInfo?.tip || 0,
    payments: [...(localPaymentInfo?.payments || [])]
  }
  paymentLeg = paymentLegStruct({ mode: selectedPayment, source: paymentInfo });
  paymentInfo.balanceAmount = balanceAmount > 0 ? balanceAmount : 0;
  if (checkoutModalStore.isSplitPayment) {
    paymentInfo.payments.push(paymentLeg);
    paidAmount = getPaymentAmount(paymentInfo.payments);
  }
  else {
    paymentInfo.payments = [paymentLeg];
  }
  if ((checkoutModalStore.transactionType === 'partialPayment' || paidAmount >= (saleData.billRoundedAmount)) && !checkoutModalStore.isCheckoutActive) {
    store.dispatch(showConfirmCta(true));
  }
  if (checkoutModalStore.isSplitPayment && !(paidAmount >= saleData.billRoundedAmount)) {
    store.dispatch(resetReference(true));
  }
  return { paymentInfo, error: false };
}

export const handleDeletePayment: any = (index: number) => {
  const localPaymentInfo = store.getState().localPaymentInfoStore?.paymentInfo,
    saleData = store.getState().saleDataStore?.saleData;

  let paymentInfo = { ...localPaymentInfo, payments: [...(localPaymentInfo?.payments || [])] }, payments = paymentInfo.payments, amount = 0;
  payments.splice(index, 1);
  if (payments?.length) {
    amount = getPaymentAmount(payments);
  }
  paymentInfo.balanceAmount = (amount > saleData.billRoundedAmount ? 0 : (saleData.billRoundedAmount - amount));
  paymentInfo.payments = payments;
  store.dispatch(updateLocalPaymentInfo(paymentInfo));
  if (amount < saleData.billRoundedAmount + (localPaymentInfo.tip || 0)) {
    store.dispatch(showConfirmCta(false));
  }
  return paymentInfo;
}

export const getPaymentAmount: any = (payments: any = []) => {
  let amount = 0;
  if (payments?.length) {
    payments.map((listItem: any) => {
      amount += listItem.amount;
    })
  }
  return amount;
}

export const getTenderedPaymentAmount: any = (payments: any = []) => {
  let amount = 0, localPayment = payments;
  if (localPayment && localPayment.length > 0) {
    localPayment.forEach((listItem: any) => {
      if (listItem.amount && listItem.amount >= 0) amount += parseFloat(listItem.amount);
    })
  }
  return amount;
}

export const getNewTenderedPaymentAmount: any = (payments: any = {}, isReturnSale: boolean) => {
  let amount = 0, localPayment = new Map(payments);
  if (localPayment && localPayment.size > 0) {
    localPayment.forEach((listItem: any) => {
      const acutalAmount = (isReturnSale && listItem.amount <= 0) ? -1 * listItem.amount : listItem.amount;
      if (listItem.amount && acutalAmount >= 0) amount += parseFloat(acutalAmount);
    })
  }
  return amount;
}

export const recalculateAmount: any = (payments: any = {}, mode?: string) => {
  const legs = [...new Map(payments).values()];
  if (!mode) {
    mode = (legs.at(-1) as any)?.mode;
  }
  const isReturnSale = store.getState().checkoutModalStore.returnSale || false;
  const saleData = store.getState().saleDataStore?.saleData;
  const paymentDefObj = arrayToMap(store.getState().businessStore?.businessData?.paymentdefs, 'mode')[mode as string];

  const tenderedAmount = getNewTenderedPaymentAmount(payments, isReturnSale);
  const billAmount = !isReturnSale ? roundOffBillAmount(paymentDefObj, saleData.billTotal ?? saleData.billRoundedAmount, { payments: legs }) : saleData.billRoundedAmount;

  return roundOffTwoDecimal(billAmount - (isReturnSale ? -tenderedAmount : tenderedAmount));
};

export const recalculateAmountMobile: any = (payments: any) => {
  const localPaymentInfo = store.getState().localPaymentInfoStore?.paymentInfo,
    saleData = store.getState().saleDataStore?.saleData;
  const tipAmount = getTipAmount();
  let tenderedAmount = saleData.billRoundedAmount + tipAmount;
  if (payments?.size > 0) {
    let { amount } = paymentHelpers.getNewPaymentInfo(payments);
    return roundOffTwoDecimal(tenderedAmount - amount);
  }
  return tenderedAmount;
}

export const handleAmountPaid: any = (enteredAmount: any) => {
  const selectedPayment: any = SELECTED_PAYMENT_STORE_SELECTED_PAYMENT;
  if (selectedPayment.mode) {
    if (enteredAmount >= 0) {
      if (selectedPayment.referenceMandatory && !selectedPayment.reference) {
        handleWarningModal("Reference is requred.")
        return true;
      }
      let { paymentInfo, error }: any = getPaymentInfo(enteredAmount);
      if (error) {
        handleWarningModal(error);
        return error;
      }
      store.dispatch(updateLocalPaymentInfo(paymentInfo));
    }
  }
}

export const getTipAmount: any = () => {
  let tipAmount = 0;
  const localPaymentInfo = store.getState().localPaymentInfoStore?.paymentInfo;
  if (localPaymentInfo?.tip) {
    return localPaymentInfo.tip;
  }
  return tipAmount;
}

export const getPaymentMethods: any = () => {
  const businessData = store.getState().businessStore?.businessData;
  return getPermittedPaymentModes(businessData?.paymentdefs);
}

export const checkValidAmount: any = (enteredAmount: any) => {
  const isReturnSale = store.getState().checkoutModalStore.returnSale || false;
  const paymentInfo = getPaymentInfoFromReducer(), saleData = getClonedSaleDataFromReducer();
  enteredAmount = parseFloat(enteredAmount);
  if (saleData?.paymentInfo?.balanceAmount - enteredAmount >= 1 && !isReturnSale) {
    handleWarningModal("UI_MSG_AMOUNT_LESS_THAN_BALANCE");
    return false;
  }
  return true;
}

export const handleSave: any = (saleData: any, cb: any) => {
  saleData = calculateSale(structuredClone(saleData));
  let dataToSend = {
    postBody: saleData,
    callback: cb
  };
  // store.dispatch(handleSaveSaleData(dataToSend));
  saleCheckoutSave(dataToSend);
}

interface Payload {
  postBody: any,
  callback: (...args: any[]) => void
}

export const handleSaleClose: any = (payload: Payload) => {
  // store.dispatch(updatePaymentToServer(payload));
  closeSaleFn(payload);
}

export const getQuickPaymentFromReducer: any = () => {
  let quickPayment = store.getState().businessStore?.businessData?.quickPaymentModes || [];
  return quickPayment;
}

export const getPaymentDefsFromReducer: any = () => {
  return store.getState().businessStore?.businessData?.paymentdefs || [];
}


export const getPaymentBasedOnChannel: any = (paymentList: any = [], channelDefId: any = '') => {
  let filterData = [];
  filterData = paymentList.filter((listItem: any) => (!listItem.channelDefIds || listItem.channelDefIds.includes(channelDefId)));
  return filterData;
}

// Moved to @rista/core/helpers/paymenthelper with the feature gate (web's bodies). IMPORTED as well
// as re-exported — this file calls `getPermittedPaymentModes` in its own body above (ledger rule 5).
export { quickPaymentFilter, getPermittedPaymentModes, getQuickPaymentMethods } from "@rista/core/helpers/paymenthelper";
import { getPermittedPaymentModes } from "@rista/core/helpers/paymenthelper";

export const onPaymentSave = (checkoutContext: any) => {
  let { selectedPayment, payments } = checkoutContext, paymentValues: any = {},
    paymentRecord = getPaymentInfoFromReducer(),
    // paymentModalPanel, errors = [], customerInfo = saleRecord.get('customerInfo'), prepaidModeRef, prepaidProcessInput,
    balanceAmount = paymentRecord.balanceAmount;
  // paymentId = payment.get('paymentId'), paymentPrefs = posPreferences.payments || {};
  if (payments.get(selectedPayment.paymentId)) {
    paymentValues = { ...payments.get(selectedPayment.paymentId) };
    // balanceAmount += paymentValues.amount;
  }
  paymentValues.amount = parseFloat(paymentValues.amount);
  //Ignore 0 value payments.
  if (paymentValues.amount && !validatePayment(paymentValues)) {
    handleWarningModal(getErrorMessage('UI_INVALID_PAYMENT_AMOUNT'));
    return false;
  }
  if (paymentValues.amount && paymentValues.referenceMandatory && !paymentValues.reference) {
    handleWarningModal(getErrorMessage('UI_VALIDATION_ERR_REQUIRED', 'Reference'));
    return false;
  }
  //Allow payment with 0 value. Do not record any payment leg.
  if (paymentValues.amount) {

    // if (saleRecord.get('transactionType').toLowerCase() === 'return') {
    //     paymentValues.amount = -paymentValues.amount;
    //     if (Math.abs(balanceAmount) >= 0
    //         && (balanceAmount - paymentValues.amount) > 0) {
    //           handleWarningModal(getErrorMessage('UI_RTN_PAYMNT_GT_BAL'))
    //         return;
    //     }
    // } else {
    if (paymentValues.amount < balanceAmount) {
      handleWarningModal(getErrorMessage('UI_MSG_AMOUNT_LESS_THAN_BALANCE'))
      return false;
    }
    if ((!paymentValues?.isCash) && paymentValues.amount > balanceAmount) {
      handleWarningModal(getErrorMessage('UI_MSG_AMOUNT_GT_BALANCE_NONCASH'))
      return false;
    }
    // }
    // payment.set('amount', paymentValues.amount);
    // Keeping existing paymentBy info, because the intent might be to just modify the payment info, not exactly post. Will add to auditLog later to identify who modified.
    // payment.set('paymentBy', null);
    // if(payment.get('mode') !== 'Cash') {
    //     payment.set('reference', paymentValues.reference);
    // }
    //Logic to add prepaid amount.
    // if (payment.get('mode') === 'Prepaid') {
    //     prepaidModeRef = Ext.getStore('payment_mode_store').findRecord('mode', 'Prepaid').getData();
    //     if (AppContext.businessData.authenticateCustomer) {
    //         if (!(customerInfo && customerInfo.customerRefId)) {
    //             Rista.CommonHelper.showToast(Rista.MessageUtil.getMessage('UI_ERR_NO_CUSTOMER'));
    //             return;
    //         }
    //         Rista.CommonHelper.getComponent('maincontainer').fireEvent('showcustauth',
    //         {sale: saleRecord.getData(), source: {sourceView: paymentModePanel, data: payment}});
    //     } else {
    //         if (!Ext.isEmpty(qrDataField.getValue())) {
    //             prepaidProcessInput = {result: qrDataField.getValue()};
    //             //Immediately hide to avoid copying of QR code.
    //             qrDataField.reset();
    //             Rista.CommonHelper.getComponent('paymentmodepanel').fireEvent('process', 'Prepaid', prepaidProcessInput);
    //         }
    //         else if (Rista.AppConstants.getDeviceReady() && Rista.CommonHelper.isPluginEnabled("barcodeScanner")) {
    //             cordova.plugins.barcodeScanner.scan(this.barcodeSuccess, this.barcodeFailure);
    //         } else {
    //             Rista.CommonHelper.showToast(Rista.MessageUtil.getMessage('UI_MSG_FEATURE_UNAVAILABLE'));
    //         }
    //     } /*else {
    //         //Changed logic to always take customer details when attached in sale and skipValidation is on

    //         if (customerInfo && Ext.isEmpty(customerInfo.activeToken)) {
    //             prepaidProcessInput = {customerRefId: customerInfo.customerRefId, accountUUID: accountUUID};
    //         } else {
    //             prepaidProcessInput = {result: customerInfo.activeToken + '|' + accountUUID};
    //         }

    //         prepaidProcessInput = {customerRefId: customerInfo.customerRefId, accountUUID: accountUUID};

    //         Rista.CommonHelper.getComponent('paymentmodepanel').fireEvent('process', 'Prepaid', prepaidProcessInput);
    //         return;
    // }*/
    //     return;
    // }
    // if (payment.get('mode') === 'Loyalty') {
    //     this.onPaymentModePanelProcess('Loyalty');
    //     return;
    // }
    // //Later
    // if (payment.get('type') === 'External') {
    //     this.showExternalPayment(payment);
    //     return;
    // }
    // If Voucher redeem amount is changed from the face value
    // if (paymentValues.get('type') === 'Coupon' &&
    //     paymentValues.get('amount') !== payment.get('requestAmount')) {
    //     if (payment.get('amount') > payment.get('requestAmount')) {
    //         Ext.Msg.alert('', Rista.MessageUtil.getMessage('UI_COUPON_AMOUNT_EXCEEDED'));
    //         return;
    //     }
    //     payment.set('isOverridden', true);
    // }
    // paymentsStore.add(payment);
  }
  return true;
  // if (paymentModePanel.getSource().getItemId() === 'paymentMainContainer') {
  //     paymentMainContainer = this.getPaymentMainContainer();
  //     paymentMainContainer.animateActiveItem(paymentContainer,
  //                                            {type: 'fade', duration: 100});
  //     Rista.BackButtonUtil.popFromViewStack();
  // } else {
  //     paymentModalPanel = this.getPaymentModalPanel();
  //     paymentModalPanel.hide();
  //     this.onPaymentDone();
  // }

  // onPaymentDone();
}

export const getPaymentInfoFromReducer = () => {
  const paymentInfo = store.getState().localPaymentInfoStore?.paymentInfo || {};
  return structuredClone(paymentInfo);
}

export const validatePayment = (paymentLeg: any) => {
  var amount = paymentLeg.amount;
  if (amount && !isNaN(amount)) {
    return true;
  }
  return false;
}

// export const updateCheckoutContextData = (checkoutContextState: any) =>{
//   const {selectedPayment, payments} = checkoutContextState;
//   let checkoutPayments = newMapData(checkoutContextState.payments);
//   checkoutPayments.set(selectedPayment.paymentId, selectedPayment);
//   setCheckoutContextState({selectedPayment: selectedPayment, payments: checkoutPayments});
// }

export function checkSaleOrderError(res: any) {
  if (res?.errors?.length || hasItemLeveErrors(res?.saleItems?.errors)) {
    if (res?.errors?.length && res?.error?.includes(INSUFFICIENT_STOCK)) {
      store.dispatch(orderLevelError({ isToastOpen: true, toastMessage: res.errors, toastType: 'error' }))
    }
    calculateAndSaveSaleData(res);
    return true;
  }
  return false
}

export function handlePaymentInfo(selectedPayment: any) {
  const paymentInfo = getPaymentInfoFromReducer(), saleData = getClonedSaleDataFromReducer();
  let balanceAmount = 0;
  balanceAmount = paymentInfo?.balanceAmount;
  if (selectedPayment?.isCash) {
    if (balanceAmount > 0) {
      addCashAmounts(balanceAmount, saleData);
    }
  }
  else {
    showRefrenceStrip();
  }
}

export function validatePayments(paymentValue: any = {}) {
  if (paymentValue.amount && !validatePayment(paymentValue)) {
    handleWarningModal(getErrorMessage('UI_INVALID_PAYMENT_AMOUNT'));
    return false;
  }
  if (paymentValue.amount && paymentValue.referenceMandatory && !paymentValue.reference) {
    handleWarningModal(getErrorMessage('UI_VALIDATION_ERR_REQUIRED', 'Reference'));
    return false;
  }
  return validateAmount(paymentValue);
}

export function validateAmount(paymentValue: any) {
  const isReturnSale = store.getState().checkoutModalStore.returnSale || false;
  const paymentInfo = getPaymentInfoFromReducer();
  let balanceAmount = isReturnSale
    ? paymentInfo.balanceAmount < 0 ? -1 * paymentInfo.balanceAmount : paymentInfo.balanceAmount
    : paymentInfo.balanceAmount;
  if (paymentInfo?.payments?.length) {
    paymentInfo.payments.forEach((element: any) => {
      if (element.paymentId === paymentValue.paymentId) balanceAmount += element.amount;
    });
  }

  if (!paymentValue?.isCash) {
    if (paymentValue.amount > balanceAmount) {
      handleWarningModal("UI_MSG_AMOUNT_GT_BALANCE_NONCASH");
      return false;
    }
  }
  return true;
}

export function updateLocalPayments(res: any, checkoutContext: any, setCheckoutContextState: any) {
  let { selectedPayment, payments } = checkoutContext, hasError = false;
  if (res.paymentInfo?.payments?.length) {
    res.paymentInfo.payments.forEach((paymentValue: any) => {
      if(paymentValue?.type === DISCOUNT_MODES.coupon) return;
      if (selectedPayment.paymentId === paymentValue.paymentId) {
        selectedPayment = { ...paymentValue };
        if (paymentValue.paymentStatus === FAILED || paymentValue.paymentStatus === ERROR) {
          hasError = true;
        }
      }
      payments.set(paymentValue.paymentId, paymentValue);
    });
    store.dispatch(saveSaleData(res));
  }
  return {
    hasError,
    selectedPayment,
    payments
  };
}

export function checkExternalMultiplePayments(payments: any) {
  let paymentsLocalContext: any = new Map(payments), isExternalPaymentPresent = false, isSplitType = false;;
  paymentsLocalContext.forEach((paymentList: any, key: any) => {
    if (paymentList?.type?.toLowerCase !== COUPON) {
      isSplitType = true;
    }
    if (paymentList.type === EXTERNAL && paymentList?.paymentStatus) isExternalPaymentPresent = true;
  })
  if (isSplitType) {
    store.dispatch(updateTransactionType(SPLIT_PAYMENT_KEY));
    if (isExternalPaymentPresent) store.dispatch(hideFullPayment(true));
  }
}

export function getSelectedAmount(selectedPayment: any) {
  const paymentInfo = getPaymentInfoFromReducer();
  if (paymentInfo.payments?.length) {
    paymentInfo.payments.forEach((element: any) => {
      if (element.paymentId === selectedPayment.id) return element.amount;
    })
  }
  return 0
}

export function selectFirstPaymentMethod(
  checkoutContextState: any,
  setCheckoutContextState: any,
  UpdatePaymentLeg: any,
  sale: any
) {
  let { payments } = checkoutContextState;
  let paymentMethods = getPaymentMethods().filter(
    (val: any) => !DISABLED_PAYMENTS.includes(val?.mode)
  );
  let paymentLeg = UpdatePaymentLeg(paymentMethods[0]);
  paymentLeg.amount = sale.billRoundedAmount;
  setCheckoutContextState({ selectedPayment: paymentLeg, payments });
}

export function hasIsCashPaymentMethod(paymentMethods: Map<string, any>[]) {
  if (!paymentMethods?.length) return false;
  return paymentMethods.some(
    (paymentMethod: any) => paymentMethod.isCash
  );
}